import React, { useEffect, useState } from 'react';
import { X, Bell } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const AnnouncementBar: React.FC = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(location.pathname === '/');
  }, [location.pathname]);

  const handleClose = () => setIsVisible(false);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.4 }}
          className="w-full bg-gradient-to-r from-blue-700 to-blue-800 text-white shadow-md z-50"
        >
          <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center relative">
            <div className="flex items-center space-x-3">
              <motion.div
                animate={{ scale: [1, 1.2, 1], rotate: [0, 5, -5, 0] }}
                transition={{ duration: 1.5, repeat: Infinity, repeatType: 'loop' }}
              >
                <Bell className="w-5 h-5 text-yellow-300" />
              </motion.div>
              <p className="text-sm font-medium">
                UTR Therapeutics Inc. Announces U.S. FDA Orphan Drug Designation and Rare Pediatric Disease Designation for UTRxMYCN M1-14...
              </p>
              <a
                href="https://www.prnewswire.com/news-releases/utr-therapeutics-inc-announces-us-fda-orphan-drug-designation-and-rare-pediatric-disease-designation-for-utrxmycn-m1-14-302893199.html?tc=eml_cleartime"
                target="_blank"
                rel="noopener noreferrer"
                className="underline font-semibold text-sm hover:text-blue-200"
              >
                Read more →
              </a>
            </div>
            <motion.button
              onClick={handleClose}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="p-1.5 rounded-full bg-white/20 hover:bg-white/30 transition"
              aria-label="Close announcement"
            >
              <X className="h-4 w-4 text-white" />
            </motion.button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AnnouncementBar;
